import script from "./SidebarLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&setup=true&lang=js"

import "./SidebarLayout.vue?vue&type=style&index=0&id=2cc68ca1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc68ca1"]])

export default __exports__